/**
 * @file JobId URL 同步服务
 * @description 以 URL query 中的 jobId 作为唯一数据源
 *
 * 使用方式：
 * 1. 在 SiderLayout 中调用 jobIdSyncService.setNavigate(navigate) 注入 navigate
 * 2. 所有写 selectedJobId 的地方改用 jobIdSyncService.setJobId() / clearJobId()
 * 3. 页面初始化时用 jobIdSyncService.getJobIdFromUrl() 从 URL 读取
 */
import {NavigateFunction} from 'react-router-dom';

class JobIdSyncService {
    private navigate: NavigateFunction | null = null;
    private pendingJobId: string | null | undefined;

    /** 注入 navigate 函数（在 SiderLayout 挂载时调用） */
    setNavigate(navigate: NavigateFunction) {
        this.navigate = navigate;
        if (this.pendingJobId !== undefined) {
            this.syncUrl(this.pendingJobId);
            this.pendingJobId = undefined;
        }
    }

    /** 从 URL query 参数中获取 jobId */
    getJobIdFromUrl(): string | null {
        return new URLSearchParams(window.location.search).get('jobId');
    }

    /**
     * 设置 jobId
     * 仅同步写入 URL query 参数
     * @param jobId 任务 ID
     */
    setJobId(jobId: string) {
        this.syncUrl(jobId);
    }

    /** 从 URL query 参数中移除 jobId */
    clearJobId() {
        this.syncUrl(null);
    }

    private syncUrl(jobId: string | null) {
        const params = new URLSearchParams(window.location.search);
        if (jobId) {
            params.set('jobId', jobId);
        } else {
            params.delete('jobId');
        }
        const searchStr = params.toString();
        const search = searchStr ? `?${searchStr}` : '';

        if (!this.navigate) {
            this.pendingJobId = jobId;
            window.history.replaceState(null, '', `${window.location.pathname}${search}${window.location.hash}`);
            return;
        }

        this.navigate({search}, {replace: true});
    }
}

export const jobIdSyncService = new JobIdSyncService();
